var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//!!!! WARNING !!!!!!!!
//This is an auto generated file.
//Changes to this code will be lost if the code is regenerated.
//Generated by: TsAppClientApiPrinter
//Contact #dev-ui-platform-support in case of issues
import { GeneratedApiClient } from "../ApiClient";
import { HttpMethod, AuthStrategy } from "../HttpClient";
/* tslint:disable:no-namespace */
export var FleetOwnerReportingService;
(function (FleetOwnerReportingService) {
    var ApiClientClass = /** @class */ (function (_super) {
        __extends(ApiClientClass, _super);
        function ApiClientClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** Generated from: {@link [CompanyReportController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/CompanyReportController.ts)} */
            _this.generateReportRequest = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/generateReportRequest",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyReportController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/CompanyReportController.ts)} */
            _this.getCompanyReports = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCompanyReports",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [InvoicingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/InvoicingController.ts)} */
            _this.getRiderInvoices = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getRiderInvoices",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [InvoicingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/InvoicingController.ts)} */
            _this.getBillingModel = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getBillingModel",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [InvoicingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/InvoicingController.ts)} */
            _this.getTaxifyInvoices = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getTaxifyInvoices",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [InvoicingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/InvoicingController.ts)} */
            _this.getTaxifyInvoicePdf = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getTaxifyInvoicePdf",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [InvoicingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/InvoicingController.ts)} */
            _this.getCompensations = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCompensations",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [InvoicingController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/InvoicingController.ts)} */
            _this.getCompensationPdf = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCompensationPdf",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [ReportController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/ReportController.ts)} */
            _this.getWeeklyCsv = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getWeeklyCsv",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [ReportController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/ReportController.ts)} */
            _this.getDailyCsv = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDailyCsv",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [ReportController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/ReportController.ts)} */
            _this.getOrdersCsv = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getOrdersCsv",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [ReportController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/ReportController.ts)} */
            _this.getOrdersCsvV2 = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getOrdersCsvV2",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [ReportController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/ReportController.ts)} */
            _this.getPayouts = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getPayouts",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [OrderHistoryController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/OrderHistoryController.ts)} */
            _this.getOrdersHistoryCsv = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getOrdersHistoryCsv",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [BrandingBonusController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/BrandingBonusController.ts)} */
            _this.companyHasBrandingBonus = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/companyHasBrandingBonus",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [BrandingBonusController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/BrandingBonusController.ts)} */
            _this.getBrandingBonusWeeklyCsv = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getBrandingBonusWeeklyCsv",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [OrderController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/OrderController.ts)} */
            _this.getOrders = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getOrders",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [OrderController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/OrderController.ts)} */
            _this.getOrdersHistory = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getOrdersHistory",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [OrderController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/controller/OrderController.ts)} */
            _this.getOrderSearchCategories = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getOrderSearchCategories",
                            service_id: "fleet-owner-reporting",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            return _this;
        }
        return ApiClientClass;
    }(GeneratedApiClient));
    // Split class actual prototype and type
    FleetOwnerReportingService.ApiClient = ApiClientClass;
    /** Generated from: {@link [InvoicingInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/invoicing/InvoicingInternalAsyncApi.ts)} */
    var BillingModel;
    (function (BillingModel) {
        BillingModel["INTERMEDIATE"] = "intermediate";
        BillingModel["RESALE"] = "resale";
    })(BillingModel = FleetOwnerReportingService.BillingModel || (FleetOwnerReportingService.BillingModel = {}));
    /** Generated from: {@link [BrandHelper.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/util/brand/BrandHelper.ts)} */
    var BrandEnum;
    (function (BrandEnum) {
        BrandEnum["BOLT"] = "bolt";
        BrandEnum["HOPP"] = "hopp";
    })(BrandEnum = FleetOwnerReportingService.BrandEnum || (FleetOwnerReportingService.BrandEnum = {}));
    /** Generated from: {@link [CompanyReportTable.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/table/CompanyReportTable.ts)} */
    var CompanyReportStatus;
    (function (CompanyReportStatus) {
        CompanyReportStatus["PENDING"] = "pending";
        CompanyReportStatus["IN_PROGRESS"] = "in_progress";
        CompanyReportStatus["READY"] = "ready";
        CompanyReportStatus["ERROR"] = "error";
    })(CompanyReportStatus = FleetOwnerReportingService.CompanyReportStatus || (FleetOwnerReportingService.CompanyReportStatus = {}));
    /** Generated from: {@link [CsvUtils.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/common/utils/CsvUtils.ts)} */
    var DecimalSeparator;
    (function (DecimalSeparator) {
        DecimalSeparator["DOT"] = "dot";
        DecimalSeparator["COMMA"] = "comma";
    })(DecimalSeparator = FleetOwnerReportingService.DecimalSeparator || (FleetOwnerReportingService.DecimalSeparator = {}));
    /** Generated from: {@link [ReportService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/main/reporting/service/ReportService.ts)} */
    var GetOrdersCsvOrderStates;
    (function (GetOrdersCsvOrderStates) {
        GetOrdersCsvOrderStates["CLIENT_CANCELLED"] = "client_cancelled";
        GetOrdersCsvOrderStates["DRIVER_DID_NOT_RESPOND"] = "driver_did_not_respond";
        GetOrdersCsvOrderStates["DRIVER_REJECTED"] = "driver_rejected";
        GetOrdersCsvOrderStates["CLIENT_DID_NOT_SHOW"] = "client_did_not_show";
        GetOrdersCsvOrderStates["FINISHED"] = "finished";
        GetOrdersCsvOrderStates["DRIVER_CANCELLED_AFTER_ACCEPT"] = "driver_cancelled_after_accept";
    })(GetOrdersCsvOrderStates = FleetOwnerReportingService.GetOrdersCsvOrderStates || (FleetOwnerReportingService.GetOrdersCsvOrderStates = {}));
    /** Generated from: {@link [RideHailingBillingInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/ride_hailing_billing/RideHailingBillingInternalAsyncApi.ts)} */
    var InvoiceDocumentSource;
    (function (InvoiceDocumentSource) {
        InvoiceDocumentSource["INVOICING"] = "invoicing";
        InvoiceDocumentSource["BILLING_DOCUMENT"] = "billing_document";
    })(InvoiceDocumentSource = FleetOwnerReportingService.InvoiceDocumentSource || (FleetOwnerReportingService.InvoiceDocumentSource = {}));
    /** Generated from: {@link [BillingDocumentInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/billing_document/BillingDocumentInternalAsyncApi.ts)} */
    var InvoiceSubType;
    (function (InvoiceSubType) {
        InvoiceSubType["ISSUE"] = "issue";
        InvoiceSubType["REFUND"] = "refund";
        InvoiceSubType["PARTIAL_REFUND"] = "partial_refund";
        InvoiceSubType["CREDIT"] = "credit";
        InvoiceSubType["RE_ISSUE"] = "re_issue";
        InvoiceSubType["STATEMENT"] = "statement";
        InvoiceSubType["DELIVERY_NOTE"] = "delivery_note";
        InvoiceSubType["RECEIPT"] = "receipt";
        InvoiceSubType["CORRECTION"] = "correction";
        InvoiceSubType["LEGACY_CREDIT_NOTE"] = "legacy_credit_note";
        InvoiceSubType["MANUAL_CORRECTION"] = "manual_correction";
        InvoiceSubType["CREDIT_STATEMENT"] = "credit_statement";
    })(InvoiceSubType = FleetOwnerReportingService.InvoiceSubType || (FleetOwnerReportingService.InvoiceSubType = {}));
    /** Generated from: {@link [OrderHistoryInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/gen/internalPrivateApi/FleetOwnerReporting/OrderHistoryInternalAsyncApi.ts)} */
    var OrderTryOfferState;
    (function (OrderTryOfferState) {
        OrderTryOfferState["DRIVER_BOOKING"] = "driver_booking";
        OrderTryOfferState["WAITING_DRIVER_CONFIRMATION"] = "waiting_driver_confirmation";
        OrderTryOfferState["CLIENT_CANCELLED"] = "client_cancelled";
        OrderTryOfferState["DRIVER_DID_NOT_RESPOND"] = "driver_did_not_respond";
        OrderTryOfferState["DRIVER_REJECTED"] = "driver_rejected";
        OrderTryOfferState["DRIVER_ACCEPTED"] = "driver_accepted";
        OrderTryOfferState["DRIVER_ARRIVED_TO_CLIENT"] = "driver_arrived_to_client";
        OrderTryOfferState["CLIENT_DID_NOT_SHOW"] = "client_did_not_show";
        OrderTryOfferState["DRIVING_WITH_CLIENT"] = "driving_with_client";
        OrderTryOfferState["ARRIVED_TO_DESTINATION"] = "arrived_to_destination";
        OrderTryOfferState["FINISHED"] = "finished";
        OrderTryOfferState["PAYMENT_BOOKING_FAILED"] = "payment_booking_failed";
        OrderTryOfferState["OFFER_REJECTED"] = "offer_rejected";
    })(OrderTryOfferState = FleetOwnerReportingService.OrderTryOfferState || (FleetOwnerReportingService.OrderTryOfferState = {}));
    /** Generated from: {@link [OrderHistoryInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/driver/fleet_owner/gen/internalPrivateApi/FleetOwnerReporting/OrderHistoryInternalAsyncApi.ts)} */
    var OrderTryStateCustom;
    (function (OrderTryStateCustom) {
        OrderTryStateCustom["DRIVER_CANCELLED_AFTER_ACCEPT"] = "driver_cancelled_after_accept";
    })(OrderTryStateCustom = FleetOwnerReportingService.OrderTryStateCustom || (FleetOwnerReportingService.OrderTryStateCustom = {}));
    /** Generated from: {@link [InvoicingUserInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/invoicing_user/InvoicingUserInternalAsyncApi.ts)} */
    var UserInvoicePaymentMethodType;
    (function (UserInvoicePaymentMethodType) {
        UserInvoicePaymentMethodType["BUSINESS"] = "business";
        UserInvoicePaymentMethodType["APP_PAYMENT"] = "app_payment";
        UserInvoicePaymentMethodType["CASH"] = "cash";
        UserInvoicePaymentMethodType["CARD"] = "card";
    })(UserInvoicePaymentMethodType = FleetOwnerReportingService.UserInvoicePaymentMethodType || (FleetOwnerReportingService.UserInvoicePaymentMethodType = {}));
})(FleetOwnerReportingService || (FleetOwnerReportingService = {}));
